<template>
    <div>
        <div
            class="overflow-hidden"
            :class="{ 'h-0': !isOpen }"
            ref="description"
        >
            <slot/>
        </div>
        <div class="mb-2">
            <slot name="toggle"></slot>
        </div>
        <button
            @click="isOpen = !isOpen"
            class="flex items-center mx-auto py-1 px-2 text-accent font-semibold focus:outline-none"
        >
            <span class="mr-1 uppercase">{{ toggle }}</span>
            <template v-if="isOpen">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                     class="h-8 w-8 fill-current text-accent">
                    <path d="M8.7 14.7a1 1 0 0 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L12 11.42l-3.3 3.3z"/>
                </svg>
            </template>
            <template v-else>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                     class="h-8 w-8 fill-current text-accent">
                    <path
                        d="M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"/>
                </svg>
            </template>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        ...mapGetters({
            _: 'localisation/translate',
        }),
        toggle() {
            return `${this.isOpen ? this._('pack_card_hide_features') : this._('pack_card_all_features')} `
        },
    },
}
</script>
